// source: livongo/protobuf/common/user/biometricAlerts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var livongo_protobuf_common_types_absoluteTimestamp_pb = require('../../../../livongo/protobuf/common/types/absoluteTimestamp_pb.js');
goog.object.extend(proto, livongo_protobuf_common_types_absoluteTimestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Alert', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Label', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Question', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Severity', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.Alert, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.Alert';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.Severity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.Severity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.Label, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.Label.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.Label';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.common.user.biometricAlerts.Question.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.Question, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.Question.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.Question';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.displayName = 'proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.toObject = function(includeInstance, msg) {
  var f, obj = {
    alertId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    memberUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    alertType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    alertTriggerRule: (f = msg.getAlertTriggerRule()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    triggerValue: (f = msg.getTriggerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    state: jspb.Message.getFieldWithDefault(msg, 6, 0),
    alertResult: jspb.Message.getFieldWithDefault(msg, 7, 0),
    flowStartedTstz: (f = msg.getFlowStartedTstz()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    alertDuration: (f = msg.getAlertDuration()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.Alert;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAlertId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberUuid(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} */ (reader.readEnum());
      msg.setAlertType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setAlertTriggerRule(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTriggerValue(value);
      break;
    case 6:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 7:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} */ (reader.readEnum());
      msg.setAlertResult(value);
      break;
    case 8:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setFlowStartedTstz(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setAlertDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMemberUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAlertType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAlertTriggerRule();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTriggerValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAlertResult();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getFlowStartedTstz();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getAlertDuration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 alert_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getAlertId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setAlertId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string member_uuid = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getMemberUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setMemberUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AlertType.Values alert_type = 3;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getAlertType = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setAlertType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value alert_trigger_rule = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getAlertTriggerRule = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setAlertTriggerRule = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.clearAlertTriggerRule = function() {
  return this.setAlertTriggerRule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.hasAlertTriggerRule = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue trigger_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getTriggerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setTriggerValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.clearTriggerValue = function() {
  return this.setTriggerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.hasTriggerValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AlertState.Values state = 6;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getState = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional AlertResult.Values alert_result = 7;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getAlertResult = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setAlertResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp flow_started_tstz = 8;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getFlowStartedTstz = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 8));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setFlowStartedTstz = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.clearFlowStartedTstz = function() {
  return this.setFlowStartedTstz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.hasFlowStartedTstz = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Int32Value alert_duration = 9;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.getAlertDuration = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 9));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.setAlertDuration = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Alert} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.clearAlertDuration = function() {
  return this.setAlertDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Alert.prototype.hasAlertDuration = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.toObject = function(includeInstance, msg) {
  var f, obj = {
    biometric: jspb.Message.getFieldWithDefault(msg, 1, 0),
    readingId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    units: (f = msg.getUnits()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    severityRule: (f = msg.getSeverityRule()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    severity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    label: jspb.Message.getFieldWithDefault(msg, 5, 0),
    takenTstz: (f = msg.getTakenTstz()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} */ (reader.readEnum());
      msg.setBiometric(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReadingId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUnits(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setSeverityRule(value);
      break;
    case 4:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values} */ (reader.readEnum());
      msg.setSeverity(value);
      break;
    case 5:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values} */ (reader.readEnum());
      msg.setLabel(value);
      break;
    case 8:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setTakenTstz(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBiometric();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReadingId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getUnits();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSeverityRule();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSeverity();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLabel();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTakenTstz();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional BiometricType.Values biometric = 1;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getBiometric = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setBiometric = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 reading_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getReadingId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setReadingId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double value = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue units = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getUnits = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setUnits = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.clearUnits = function() {
  return this.setUnits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.hasUnits = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Int32Value severity_rule = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getSeverityRule = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setSeverityRule = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.clearSeverityRule = function() {
  return this.setSeverityRule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.hasSeverityRule = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Severity.Values severity = 4;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getSeverity = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setSeverity = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Label.Values label = 5;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getLabel = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setLabel = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp taken_tstz = 8;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.getTakenTstz = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 8));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.setTakenTstz = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.clearTakenTstz = function() {
  return this.setTakenTstz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricEvaluation.prototype.hasTakenTstz = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.ReadingType.Values = {
  INVALID: 0,
  BP_CUFF: 1,
  WEIGHT_SCALE: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values = {
  INVALID: 0,
  BLOOD_GLUCOSE: 1,
  BP_SYSTOLIC: 2,
  BP_DIASTOLIC: 3,
  BP_MAP: 4,
  HEART_RATE: 5,
  WEIGHT: 6
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.Severity;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Severity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Severity.Values = {
  INVALID: 0,
  UNSET: 1,
  GREEN: 2,
  YELLOW: 3,
  ORANGE: 4,
  RED: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Label.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.Label;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Label.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.Label.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Label} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Label.Values = {
  INVALID: 0,
  NO_LABEL: 1,
  IN_RANGE: 2,
  OUT_OF_RANGE: 3,
  VERY_OUT_OF_RANGE: 4,
  NO_RECENT_READINGS: 5,
  NO_READINGS: 6
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertType.Values = {
  INVALID: 0,
  GENERIC: 1,
  HEART_FAILURE: 2,
  MEDOPT_DM_HTN: 3,
  ONBOARDING_DPP: 4,
  ONBOARDING_WM: 5,
  ONBOARDING_HTN: 6,
  ONBOARDING_DM: 7,
  ONBOARDING_DM_HTN: 8,
  ONBOARDING_DM_WM: 9,
  ONBOARDING_HTN_DPP: 10,
  ONBOARDING_HTN_WM: 11,
  ONBOARDING_DM_HTN_WM: 12,
  CCM_COACHING_INTRO: 13
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertState.Values = {
  INVALID: 0,
  NO_ALERT: 1,
  BP_RETAKE: 2,
  SYMPTOM_COLLECTION: 3,
  REACHOUT_NEEDED: 4,
  COMPLETED_FLOW: 5,
  CLOSED: 6,
  REACHOUT_NOT_NEEDED: 7,
  MEDOPT_PASSIVE: 20,
  MEDOPT_UC_IDENTIFIED: 21,
  MEDOPT_UC_NOTIFIED: 22,
  MEDOPT_INITIATED_SIGNUP: 23,
  MEDOPT_ELIGIBILITY_CHECK_FAILED: 24,
  MEDOPT_ELIGIBILITY_CHECK_PASSED: 25,
  MEDOPT_TD_ACCOUNT_OK: 26,
  MEDOPT_TD_ACCOUNT_FAILED: 27,
  MEDOPT_COMPLETED_ONBOARDING: 28,
  MEDOPT_ENROLLMENT_COMPLETED: 29,
  MEDOPT_RECENTLY_GRADUATED: 30,
  MEDOPT_ACTIVE: 31,
  ONBOARDING_SKIPPED: 50,
  DPP_ONBOARDING_STARTED: 51,
  DPP_ONBOARDING_COMPLETED: 52,
  WM_ONBOARDING_STARTED: 53,
  WM_ONBOARDING_COMPLETED: 54,
  HTN_ONBOARDING_STARTED: 55,
  HTN_ONBOARDING_COMPLETED: 56,
  DM_ONBOARDING_STARTED: 57,
  DM_ONBOARDING_COMPLETED: 58,
  DM_HTN_ONBOARDING_STARTED: 59,
  DM_HTN_ONBOARDING_COMPLETED: 60,
  DM_WM_ONBOARDING_STARTED: 61,
  DM_WM_ONBOARDING_COMPLETED: 62,
  HTN_DPP_ONBOARDING_STARTED: 63,
  HTN_DPP_ONBOARDING_COMPLETED: 64,
  HTN_WM_ONBOARDING_STARTED: 65,
  HTN_WM_ONBOARDING_COMPLETED: 66,
  DM_HTN_WM_ONBOARDING_STARTED: 67,
  DM_HTN_WM_ONBOARDING_COMPLETED: 68,
  ONBOARDING_COMPLETED: 80,
  CCM_COACHING_INTRO_STARTED: 81,
  CCM_COACHING_INTRO_COMPLETED: 82,
  SKIPPED_FLOW: 83,
  CCM_COACHING_COMPLETED_FLOW: 84,
  CCM_COACHING_SKIPPED_FLOW: 85
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertResult.Values = {
  INVALID: 0,
  NONE: 1,
  ABNORMAL: 2,
  URGENT: 3,
  CRITICAL: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.AlertAction.Values = {
  INVALID: 0,
  REACH_OUT: 1,
  MUTED_BY_CLIENT: 2,
  MUTED_BY_MEMBER: 3,
  MUTED_BY_RECENT_ALERT: 4,
  MUTED_BY_COMMS_PREFERENCE: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerType.Values = {
  INVALID: 0,
  NONE: 1,
  HF_ALERT_FLOW: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TimerStatus.Values = {
  INVALID: 0,
  ACTIVE: 1,
  EXPIRED: 2
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Question.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answerCodesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    ordinal: (f = msg.getOrdinal()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    totalCount: (f = msg.getTotalCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.Question;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.Question.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswerCodes(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setOrdinal(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTotalCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.Question.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswerCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getOrdinal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string question_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.getQuestionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.setQuestionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string answer_codes = 2;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.getAnswerCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.setAnswerCodesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.addAnswerCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.clearAnswerCodesList = function() {
  return this.setAnswerCodesList([]);
};


/**
 * optional google.protobuf.Int32Value ordinal = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.getOrdinal = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.setOrdinal = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.clearOrdinal = function() {
  return this.setOrdinal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.hasOrdinal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value total_count = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.getTotalCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.setTotalCount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.Question} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.clearTotalCount = function() {
  return this.setTotalCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.Question.prototype.hasTotalCount = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answerCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    answerTstz: (f = msg.getAnswerTstz()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    answerCodesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerCode(value);
      break;
    case 3:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setAnswerTstz(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswerCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswerCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnswerTstz();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getAnswerCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string question_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.getQuestionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.setQuestionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer_code = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.getAnswerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.setAnswerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp answer_tstz = 3;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.getAnswerTstz = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.setAnswerTstz = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.clearAnswerTstz = function() {
  return this.setAnswerTstz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.hasAnswerTstz = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string answer_codes = 4;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.getAnswerCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.setAnswerCodesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.addAnswerCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.QuestionAnswer.prototype.clearAnswerCodesList = function() {
  return this.setAnswerCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.toObject = function(includeInstance, msg) {
  var f, obj = {
    biometricType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    units: (f = msg.getUnits()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    readingId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    readingTstz: (f = msg.getReadingTstz()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} */ (reader.readEnum());
      msg.setBiometricType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUnits(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReadingId(value);
      break;
    case 5:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setReadingTstz(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBiometricType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getUnits();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReadingId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getReadingTstz();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional BiometricType.Values biometric_type = 1;
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.getBiometricType = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.BiometricType.Values} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.setBiometricType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue units = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.getUnits = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.setUnits = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.clearUnits = function() {
  return this.setUnits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.hasUnits = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 reading_id = 4;
 * @return {number}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.getReadingId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.setReadingId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp reading_tstz = 5;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.getReadingTstz = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 5));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.setReadingTstz = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.clearReadingTstz = function() {
  return this.setReadingTstz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.RelevantBiometric.prototype.hasReadingTstz = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: (f = msg.getValue()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo;
  return proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue value = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} returns this
*/
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo} returns this
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.common.user.biometricAlerts.TriggeredRuleInfo.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.com.livongo.protobuf.common.user.biometricAlerts);
